import React from 'react';

import classNames from 'classnames';
import type { Task } from '@bringg/types';
import { LATE_ITEM } from '@bringg-frontend/gantt-timeline';

import { DISABLED_ITEM_CLASS_NAME, isTaskStarted } from '../../../utils/bringgTypesTransformers';
import { isLate } from '../../routes-planner/timeline-logic/tasks-logic';

interface TooltipClusterItemButtonProps {
	taskData: Task;
	highlight?: boolean;
	onClick: () => void;
	color: string;
}

const TooltipClusterItemButton = React.memo(({ taskData, highlight, onClick }: TooltipClusterItemButtonProps) => {
	const wayPoint = taskData.way_points[0];
	const late = isLate(wayPoint);
	return (
		<div
			className={classNames(
				'tooltip-cluster-item-button-container',
				{
					[DISABLED_ITEM_CLASS_NAME]: isTaskStarted(taskData.status)
				},
				{ 'bringg-icon': late },
				{ 'bringg-icon-clock': late },
				{ [LATE_ITEM]: late }
			)}
		>
			<button
				data-test-id={`tooltip-cluster-item-${taskData.id}`}
				className={classNames('tooltip-cluster-item-button', {
					'tooltip-cluster-item-button-highlight': highlight
				})}
				type="button"
				onClick={onClick}
			>
				{taskData.priority}
			</button>
		</div>
	);
});

export default TooltipClusterItemButton;
